
<span class="input-wrap">
  <input
    #codeInput
    id="codeInput"
    pInputText
    type="text"
    name="location-code"
    [formControl]="codeFC"
    placeholder="{{ 'admin.location-modal.code.placeholder' | translate }}"
    [size]="codeInput.value.length === 0 ? ('admin.location-modal.code.placeholder' | translate).length : codeInput.value.length"
   />
</span>
